<template>
    <div class="pagination-com">
        <el-pagination class="pagination-style" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="page" :page-sizes="page_sizes" :page-size="perPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total" background>
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'PaginatonCom',
    props: {
        page_sizes: {
            type: Array,
            default: () => [10, 20, 30, 50, 100, 500],
        },
        perPage: {
            type: Number,
            default: 30
        },
        total: {
            type: Number,
        },
        npage: {
            type: Number
        },
    },
    data () {
        return {
            page: this.npage
        }
    },
    methods: {
        handleSizeChange(val) { 
            this.$emit('handleSizeChange',val)
        },
        handleCurrentChange(val) {
            this.$emit('handleCurrentChange',val)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/PaginationCom.vue